import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions} from '../question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';
import {ModalService} from '../../services/modal.service';
import { ComponentsService } from '../../services/components-service';
import { QuestionFlowSessionQuery } from '../state/question-flow-session.query';

declare const $: any;

@Component({
    selector: 'app-question-checkbox-miniform',
    templateUrl: './question-checkbox-miniform.component.html',
    styleUrls: ['./question-checkbox-miniform.component.scss'],
    standalone: false
})
export class QuestionCheckboxMiniFormComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() isEmergency = false;
  @Output() questionAnswer = new EventEmitter<any>();
  @Output() openModal = new EventEmitter<any>();

  items = [];
  uniqueControlName = `checkbox-miniform-name-${newGuid()}`;
  selectedItem: any;
  initialAnswer = '';
  questions: any;
  session_details: any;
  constructor(
    private questionService: GlobalQuestionService,
    private modalService: ModalService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
    private componentsService: ComponentsService
  ) {
  }

  ngOnInit(): void {
   
    this.session_details = this.questionFlowSessionQuery.getValue();
    this.componentsService.getMiniFormQuestion().subscribe( questions => {
      if (questions.every(q => q.answer)) {
        this.questionService.saveAnswersOnly(questions);
         this.submitAnswer();
      } 
    })
  }

  ngAfterViewInit(): void {
    this.questionService.initPopoverCustomize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
      if (this.question?.answer) {
        this.initialAnswer = this.question?.answer;
      }
      this.setupOptions();
    }
  }

  setupOptions(): void {
    this.items = [];
    if (this.question?.options) {
      const options: any[] = parseOptions(this.question?.options);
      console.log(options)
      if (options?.length) {
        for (const option of options) {
          let answers = [];
          if (this.question?.answer) {
            answers = this.question?.answer?.split('|');
          }

          const item = {
            answer: option?.answer,
            question_id : option?.cent_aq_question_id,
            checked: option?.checked,
            order: option?.order,
            item_id: option?.item_id,
            detail: option?.detail,
            image_url: option?.image_url,
            info_comment: option?.info_comment
          };
          this.items?.push(item);
        }

        if (this.items?.length) {
          this.items?.sort((a, b) => a.answer_order > b.answer_order ? 1 : a.answer_order < b.answer_order ? -1 : 0);
        }
      }
    }
  }

  emitOpenModal(type: string, item: any): void {
    this.selectedItem = item;
    this.openModal.emit({type, item});
  }

  checkSelect(index: number): void {
    this.items[index].checked = !this.items[index].checked;
    let option = this.items[index];
    this.getMiniFormQuestions(option);
    //this.submitAnswer();
  }
  getMiniFormQuestions(option: any): void {
    if (!option?.checked) return;
    this.questionService.spinner(true);
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.session_details?.session_id);
    parameters.set('category_id', this.session_details?.category_id);
    parameters.set('group_id', this.session_details?.group_id);
    parameters.set('flow_id', this.question?.flow_id.toString());
    parameters.set('item_id', option.item_id.toString());
    parameters.set('question_id', this.question?.cent_aq_question_id.toString());
    this.questionService.runCommandNew('getMiniForm_questions', parameters).subscribe(questions => {
        this.questions = JSON.parse(questions[0]?.flowquestions);
        if (this.questions?.length) {
          this.questions?.sort((a, b) => a.page_index > b.page_index ? 1 : a.page_index < b.page_index ? -1 : 0);
        }
          this.questions.forEach(q => {
            q.item_id = option.item_id;
          });
          
          this.componentsService.setMiniFormQuestion(this.questions);
        $('#mini-form-modal').modal('show');
        this.questionService.spinner(false);
        
    });
  }
  submitAnswer(): void {
    const answers = [];
    for (const item of this.items) {
      if (item?.checked) {
        answers?.push(item?.answer);
      }
    }
    if (this.question) {
      this.question.answer = answers?.join('|');
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(answers?.join('|'));
    }
  }
}
